import { render, staticRenderFns } from "./LessonsListPanel.vue?vue&type=template&id=5b682b22&scoped=true&"
import script from "./LessonsListPanel.vue?vue&type=script&lang=ts&"
export * from "./LessonsListPanel.vue?vue&type=script&lang=ts&"
import style0 from "./LessonsListPanel.vue?vue&type=style&index=0&id=5b682b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b682b22",
  null
  
)

export default component.exports